<template>
  <div class="list-group list-group-flush">
    <a href="#!" class="list-group-item list-group-item-action">
      <div class="row align-items-center">
        <div class="col-auto">
          <!-- Avatar -->
          <img :alt="comment.userInfo.userPictureUrl" :src="comment.userInfo.userPictureUrl" class="avatar rounded-circle">
        </div>
        <div class="col ml--2">
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <h4 class="mb-0 text-sm">{{ `${comment.userInfo.userFirstName} ${comment.userInfo.userLastName}`}}</h4>
            </div>
            <div class="text-right text-muted">
              <small> {{ comment.timestamp | moment("from") }} </small>
            </div>
          </div>
          <p class="text-sm mb-0">{{ comment.text }}</p>
        </div>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  name: 'CommentNotification',
  props: {
    comment: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>

</style>
